export default "__VITE_ASSET__b3e9b535__"